import { createContext } from 'react';
const contextManager = new Map();
export default function getContext(key, defaultValue) {
    {
        const context = contextManager.get(key);
        if (context) {
            return context;
        }
    }
    const context = createContext(defaultValue);
    contextManager.set(key, context);
    return context;
}
